function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import text from '../../text';
import routes from '../../routes/constants';
var Step = function(param) {
    var title = param.title, children = param.children, className = param.className, extraText = param.extraText;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('Step', _define_property({}, className, className))
    }, title && /*#__PURE__*/ React.createElement("div", {
        className: "stepHeader"
    }, title && /*#__PURE__*/ React.createElement("h4", {
        className: "stepTitle"
    }, title, " "), extraText), children, /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, text('needHelpContactUs', {
        contactUs: /*#__PURE__*/ React.createElement(Link, {
            key: "urlTerms",
            to: {
                pathname: routes.larkiWebsiteUrl.contactUs
            },
            target: '_blank'
        }, text('contactUs'))
    })));
};
var StepContent = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('StepContent', _define_property({}, className, className))
    }, children);
};
Step.Content = StepContent;
export default Step;
